import { Drawer } from "@renderbus/ui";
import { MemberSystemModalRules, RuleText } from "./atom";
import { useTranslation } from "react-i18next";
import { BindActivityInfo } from "../../types";

const ActivityRule: React.FC<{
  ruleList?: string[];
  openRuleDrawer?: boolean;
  changeDrawer?: (state: boolean) => void;
  activityInfo?: BindActivityInfo;
  className?: string;
}> = ({
  ruleList = [],
  openRuleDrawer = false,
  changeDrawer = () => {},
  activityInfo = null,
  className = "rule-text",
}) => {
  const { t } = useTranslation("topup");

  return (
    <div className={className}>
      {ruleList.length > 0 && (
        <>
          <RuleText
            onClick={() => {
              changeDrawer(true);
            }}
          >
            {t("picture_recharge_rules")}
          </RuleText>
          <Drawer
            width={480}
            open={openRuleDrawer}
            title={t("picture_recharge_rules")}
            onClose={() => {
              changeDrawer(false);
            }}
            drawerContent={
              <MemberSystemModalRules>
                {ruleList?.map((item, index) => {
                  return (
                    <p key={item}>
                      {activityInfo ? "" : `${index + 1}.`}
                      {item}
                    </p>
                  );
                })}
              </MemberSystemModalRules>
            }
          />
        </>
      )}
    </div>
  );
};
export default ActivityRule;
